module.exports = __webpack_public_path__ + "img/w17b.06891cf2.jpg";